import moment from 'moment';

import PaysonLogo from '../../assets/svg/payson.svg';
import SwishLogo from '../../assets/svg/swish.svg';
import StripeLogo from '../../assets/svg/stripe.svg'

// export const test = () => {

// }

const statusColors = {
    'waiting-for-approval': 'orange',
    'waiting-for-payment': 'orange',
    'disallowed': 'red',
    'allowed': 'green',
    'return-for-update': 'blue',
    'patient-requested-another-time': 'purple',
    'patient-rejected': 'red',
    'patient-accepted': 'green',
    'clinic-accepted-requested-time': 'green',
    'clinic-rejected-requested-time': 'orange',
    'approved-by-region-manager': 'green',
    'rejected-by-region-manager': 'red',
    'scheduled': 'green',
    'visit-rescheduled': 'green',
    'not-booked': 'red',
    'revisit-scheduled': 'green',
    'closed': 'gray',
    'in-progress': 'green',
    'waiting': 'orange',
    'canceled-by-clinic': 'red',
    'requested-new-appointment': 'orange',
    'external': 'gray',
    'waiting-for-payment-before-submission': 'orange',
    'not-scheduled': 'red',


}

const humanReadable = {
    'waiting-for-approval': 'Waiting for approval',
    'waiting-for-payment': 'Waiting for payment',
    'disallowed': 'Disallowed',
    'allowed': 'Allowed',
    'return-for-update': 'Return for update',
    'patient-requested-another-time': 'Patient requested anoother time',
    'patient-rejected': 'Cancelled by patient', //  'Rejected by patient',
    'patient-accepted': 'Patient accepted',
    'clinic-accepted-requested-time': 'Clinic accepted requested time',
    'clinic-rejected-requested-time': 'Clinic rejected requested time',
    'approved-by-region-manager': 'Approved by region manager',
    'rejected-by-region-manager': 'Rejected by region manager',
    'scheduled': 'Scheduled',
    'visit-rescheduled': 'Visit rescheduled',
    'revisit-scheduled': 'Revisit scheduled',
    'not-booked': 'Cancelled by clinician', //'Not booked',
    'closed': 'Closed',
    'waiting': 'Waiting',
    'in-progress': 'In progress',
    'canceled-by-clinic': 'Cancelled by clinician', // 'Canceled by clinic',
    'requested-new-appointment': 'Requested new appointment',
    'external': 'External transfer',
    'waiting-for-payment-before-submission': 'Waiting for payment before submission',
    'not-scheduled': 'Not scheduled',
}

const humanReadableReasonsForChange = {
    'wrongAmount': 'Wrong amount',
    'duplicatePayment': 'Duplicate payment',
    'other': 'Other'
};
const reasonsForChange = ['wrongAmount', 'duplicatePayment', 'other'];

const humanReadablePaymentMethods = {
    'onlinePayment': 'Online payment',
    'invoice': 'Invoice',
    'paymentOnSite': 'Payment on site',
    'freeCard': 'Free card',
    'freeOfCharge': 'Free of charge',
    'registeredManually': 'Registered manually',
    'swish': 'Swish',
    'stripe': 'Stripe',
    'payson': 'Payson',
    'freeOfCharge_older85': 'Free of charge - Older 85',
    'freeOfCharge_under18': 'Free of charge - Under 18',
    'freeOfCharge_under18child': 'Free of charge - Under 18 (child)',
    'freeOfCharge_under20': 'Free of charge - Under 20',
    'freeOfCharge_under23': 'Free of charge - Under 23'
};
const humanReadableStatuses = {
    'UNPAID': 'Unpaid',
    'PAID': 'Paid',
    'REFUNDED': 'Refunded',
    'PARTIALLY_REFUNDED': 'Partially refunded',
    'CANCELLED': 'Cancelled',
    'Cancelled payments': 'Cancelled payments'
};
export const humanReadableLabels = {
    'payment_cancelled': 'Payment cancelled',
    'case_cancelled': 'Case cancelled',
    'patient_deleted': 'Patient deleted',
    'refund_requested': 'Refund requested',
    'refund_pending': 'Refund pending',
    'refund_failed': 'Refund failed',
    'case_deleted': 'Case deleted',
    'early_cancellation': 'Early cancellation',
    'late_cancellation': 'Late cancellation',
    'free_card_rejected': 'Free card rejected',
    'payment_cancellation_requested': 'Payment cancellation requested'
};

export const getHumanReadableLabel = (label, lang) => {
    return humanReadableLabels?.[label] ? lang ? humanReadableLabels?.[label]?.translate(lang) : humanReadableLabels?.[label] : label;
}

export const getHumanReadableStatus = (status, lang) => {
    return humanReadableStatuses?.[status] ? lang ? humanReadableStatuses?.[status]?.translate(lang) : humanReadableStatuses?.[status] : status;
}


export const getHumanReadable = (status, lang) => {
    let _status = humanReadable?.[status] ? lang ? humanReadable?.[status]?.translate(lang) : humanReadable?.[status] : status;
    return {
        status: _status,
        color: statusColors[status]
    }
}
export const getReasonsForChange = () => {
    return reasonsForChange;
}
export const getHumanReadableReasonForChange = (reason, lang) => {
    return humanReadableReasonsForChange?.[reason] ? lang ? humanReadableReasonsForChange?.[reason]?.translate(lang) : humanReadableReasonsForChange?.[reason] : reason;
}

export const getHumanReadablePaymentMethod = (method, lang) => {
    return humanReadablePaymentMethods?.[method] ? lang ? humanReadablePaymentMethods?.[method]?.translate(lang) : humanReadablePaymentMethods?.[method] : method;
}

export const getGroupPaymentMethods = (groupData, lang = 'se') => {
    if (!groupData?._id) return [];
    const apiKey = groupData?.apiKey;
    const agentId = groupData?.agentId;
    const bankAccount = groupData?.bankAccount;
    const stripeAccountID = groupData?.stripeAccountID;

    const hasOnlinePaymentInClinic = (apiKey && agentId) || bankAccount || stripeAccountID ? true : false;

    let paymentMethods = [];


    if (hasOnlinePaymentInClinic) {
        paymentMethods.push({
            value: 'onlinePayment',
            label: getHumanReadablePaymentMethod('onlinePayment', lang)
        })
    }
    paymentMethods.push({
        value: 'invoice',
        label: getHumanReadablePaymentMethod('invoice', lang)
    })
    paymentMethods.push({
        value: 'paymentOnSite',
        label: getHumanReadablePaymentMethod('paymentOnSite', lang)
    })
    paymentMethods.push({
        value: 'freeCard',
        label: getHumanReadablePaymentMethod('freeCard', lang)
    })

    return paymentMethods;
}
export const getDetailedGroupPaymentMethods = (groupData, lang = 'se') => {
    if (!groupData?._id) return [];
    const apiKey = groupData?.apiKey;
    const agentId = groupData?.agentId;
    const bankAccount = groupData?.bankAccount;
    const stripeAccountID = groupData?.stripeAccountID;

    const canUsePaysonForPayment = groupData?.canUsePaysonForPayment;
    const canUseStripeForPayment = groupData?.canUseStripeForPayment;
    const canUseSwishForPayment = groupData?.canUseSwishForPayment;

    const labelsForPatient = groupData?.labelsForPatient || {};

    const hasOnlinePaymentInClinic = (apiKey && agentId) || bankAccount || stripeAccountID ? true : false;

    let paymentMethods = [];

    if (canUsePaysonForPayment && apiKey && agentId) {
        const type = 'payson';
        paymentMethods.push({
            type: type,
            label: labelsForPatient?.[type]?.[lang] ? labelsForPatient?.[type]?.[lang] : 'Payson'.translate(lang),
            icon: PaysonLogo
        });
    }
    if (canUseStripeForPayment && stripeAccountID) {
        const type = 'stripe';
        paymentMethods.push({
            type: type,
            label: labelsForPatient?.[type]?.[lang] ? labelsForPatient?.[type]?.[lang] : 'Stripe'.translate(lang),
            icon: StripeLogo
        });
    }
    if (canUseSwishForPayment && bankAccount) {
        const type = 'swish';
        paymentMethods.push({
            type: type,
            label: labelsForPatient?.[type]?.[lang] ? labelsForPatient?.[type]?.[lang] : 'Swish'.translate(lang),
            icon: SwishLogo
        });
    }

    paymentMethods.push({
        type: 'invoice',
        label: labelsForPatient?.['invoice']?.[lang] ? labelsForPatient?.['invoice']?.[lang] : 'Invoice'.translate(lang),
    });
    paymentMethods.push({
        type: 'paymentOnSite',
        label: labelsForPatient?.['paymentOnSite']?.[lang] ? labelsForPatient?.['paymentOnSite']?.[lang] : 'Payment on site'.translate(lang),
    });

    paymentMethods.push({
        type: 'freeCard',
        label: labelsForPatient?.['freeCard']?.[lang] ? labelsForPatient?.['freeCard']?.[lang] : 'Free Card'.translate(lang),
    });


    return paymentMethods;
}


export const formatPrice = (price, currency) => {
    if (!price && price !== 0) return null;
    const parts = price.toString().split(".");
    let leftPart = parts[0];
    let rightPart = parts[1] || "";

    rightPart = rightPart.padEnd(2, "0");

    if (leftPart.length >= 4) {
        leftPart = leftPart.replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    }

    const formattedPrice = currency ? leftPart + "," + rightPart + " " + currency : leftPart + "," + rightPart;

    return formattedPrice;
}


export const getColorLateEarly = () => {
    const colorLateEarly = true;
    const earlyColor = '#28a745';
    const lateColor = '#dc3545';
    return { colorLateEarly, earlyColor, lateColor };
}

export const checkIfCaseIsPaid = (caseData, payments = [], lang) => {
    if (!caseData?._id) return { error: 'Case not found' };
    let paymentData = caseData?.paymentData || [];
    let isCasePaid = false;
    let __paymentMethodKey = null;
    let __statusKey = null;
    if (Number(caseData?.questionaryPrice) === 0) isCasePaid = true;
    for (let i = 0; i < paymentData.length; i++) {
        let _paymentMethodKey = paymentData[i]?.currentStatus?.paymentMethod?.key || null;
        let _statusKey = paymentData[i]?.currentStatus?.status?.key || null;

        if (_statusKey !== 'UNPAID') isCasePaid = true;
        if (['invoice', 'paymentOnSite', 'freeCard'].includes(_paymentMethodKey)) isCasePaid = true;

        if (isCasePaid) {
            __paymentMethodKey = _paymentMethodKey;
            __statusKey = _statusKey;
            break;
        }
    }
    let response = {
        isPaid: false,
        paymentMethod: __paymentMethodKey ? getHumanReadablePaymentMethod(__paymentMethodKey, lang) : null,
        status: __statusKey ? getHumanReadableStatus(__statusKey, lang) : null,
        statusKey: __statusKey,
        free: Number(caseData?.questionaryPrice) === 0 ? true : false
    }
    if (!isCasePaid) {
        let _payments = payments?.length ? payments?.filter(item => item?.caseData?._id && String(item?.caseData?._id) === String(caseData._id)) : [];
        for (let i = 0; i < _payments?.length; i++) {
            const payment = _payments[i];
            const statusKey = payment?.currentStatus?.status?.key || null;
            const paymentMethodKey = payment?.currentStatus?.paymentMethod?.key || null;
            if (statusKey !== 'UNPAID' || ['invoice', 'paymentOnSite', 'freeCard'].includes(paymentMethodKey)) {
                isCasePaid = true;
                break;
            }
        }
    }
    response.isPaid = isCasePaid;
    return response;
}

export const getExtendedPaymentManagement = (groupData) => {
    if (!groupData?._id) return false;
    const extendedPaymentManagement = groupData?.canTransferPayments || false;
    return extendedPaymentManagement;
}
export const getPatientVisitCancellationReschedulingOptions = (caseData, lang = 'se') => {
    let response = { rescheduleDisallowed: false, cancelDisallowed: false, infoText: '' }
    if (!caseData?._id) return response;
    const scheduledTs = caseData?.patientReservedTimestamp;
    const cancellationAndRefundSettings = caseData?.cancellationAndRefundSettings || null;
    const patientActions = cancellationAndRefundSettings?.patientActions || null;
    if (!scheduledTs || !cancellationAndRefundSettings) return response;
    const tsNow = Math.floor(new Date().getTime() / 1000);
    const lateCancellationPeriod = cancellationAndRefundSettings?.lateCancellationPeriod || 0;
    const diffInHours = (scheduledTs - tsNow) / 3600;
    const cancellationPeriod = diffInHours > lateCancellationPeriod ? 'early' : 'late';
    if (cancellationPeriod === 'late') {
        if (patientActions?.preventLateCancellation) response.cancelDisallowed = true;
        if (patientActions?.preventLateRescheduling) response.rescheduleDisallowed = true;
        if (cancellationAndRefundSettings?.infoTextToPatientCancelOrReschedule?.late?.[lang]) {
            response.infoText = cancellationAndRefundSettings?.infoTextToPatientCancelOrReschedule?.late?.[lang];
        }

    } else if (cancellationPeriod === 'early') {
        if (patientActions?.preventEarlyCancellation) response.cancelDisallowed = true;
        if (patientActions?.preventEarlyRescheduling) response.rescheduleDisallowed = true;
        if (cancellationAndRefundSettings?.infoTextToPatientCancelOrReschedule?.early?.[lang]) {
            response.infoText = cancellationAndRefundSettings?.infoTextToPatientCancelOrReschedule?.early?.[lang];
        }
    }
    if (response?.infoText) {
        const urlRegex = /(https?:\/\/[^\s]+)/g;
        const parts = response.infoText.split(urlRegex);

        let _infoText = parts?.map?.((part, index) => {
            if (urlRegex.test(part)) {
                return (
                    <a
                        key={index}
                        href={part}
                        target="_blank"
                        rel="noopener noreferrer"
                        style={{ color: "#007bff", textDecoration: "underline" }}
                    >
                        {'Click here'.translate(lang)}
                    </a>
                );
            } else {
                return <span key={index}>{part}</span>;
            }
        });
        response.infoText = _infoText;
    }
    return response;
}

export const getUserPaymentPermissions = (uData, groupId, clinicId) => {
    if (!uData?._id || !groupId || !clinicId) return {};
    const _groupPermissions = uData?.clinicModules?.length ? uData.clinicModules : null;
    const groupPermissionsUser = uData?.groupPermissionsUser || null;
    const clinicPermissions = groupPermissionsUser?.[groupId]?.[clinicId] || [];

    let keyDict = {
        'Klinik admin': 'clinicAdmin',
        'Admin': 'admin',
        'Vårdutövare': 'clinician',
        'Support': 'support',
        'Scheduler': 'scheduler',
    };
    let userPermissions = {};
    for (let i = 0; i < _groupPermissions?.length; i++) {
        const gp = _groupPermissions[i];
        const gpName = gp?.name || null;
        const gpId = gp?._id ? String(gp._id) : null;
        const key = keyDict?.[gpName] || null;
        let hasPermission = false;
        if (key && gpId && clinicPermissions.includes(gpId)) {
            hasPermission = true;
        }
        userPermissions[key] = hasPermission;
    }
    const clinicianPermission = userPermissions?.clinician;
    const adminPermission = userPermissions?.admin;

    const groupData = uData?.clinicGroups?.find(item => String(item._id) === String(groupId)) || null;
    const clinicActions = groupData?.paymentSettings?.cancellationAndRefundSettings?.[clinicId]?.clinicActions;

    const {
        // markEarlyCancellationAsRefundRequest,
        automaticallyRefundEarlyCancellations,
        // allowLateCancellationRefund,
        allowClinicianToRefundPayment,
        allowClinicianToCreateAndEditPayments,
        allowClinicianToCancelAnUnpaidPayment,
        allowClinicianToAttachInvoices,
        allowClinicianToMarkAsPaid
    } = clinicActions || {};

    let permissions = {
        cancelVisitFromCalendarAndChooseCancellationReason: adminPermission || clinicianPermission,
        seePaymentHistory: adminPermission || clinicianPermission,
        canWriteNotes: adminPermission || clinicianPermission,
        createNewPayments: adminPermission || (clinicianPermission && allowClinicianToCreateAndEditPayments),
        refundPayments: adminPermission || (clinicianPermission && allowClinicianToRefundPayment),
        editPayments: adminPermission || (clinicianPermission && allowClinicianToCreateAndEditPayments),
        markAsPaidAndRegisterPayment: adminPermission || (clinicianPermission && allowClinicianToMarkAsPaid),
        // cancelPayments: adminPermission || (clinicianPermission && allowClinicianToCancelAnUnpaidPayment),
        cancelPayments: adminPermission || (clinicianPermission && allowClinicianToRefundPayment),
        attachInvoices: adminPermission || (clinicianPermission && allowClinicianToAttachInvoices),
        exportExcelReports: adminPermission,
        showCliniciansFilter: adminPermission
    }


    return permissions;
}

export const checkReasonsForPayment = (payment, lang = 'se') => {
    if (!payment?._id) return null;
    const lastReason = payment?.lastReason || null;
    const allReasons = payment?.allReasons || [];
    const _lastReason = lastReason ? lastReason : allReasons?.length ? allReasons[allReasons.length - 1] : null;

    const response = _lastReason?.reason?.[lang] ? _lastReason?.reason?.[lang] : null;   //_lastReason?.reason?.[lang] ? `${_lastReason?.reason?.[lang]}${_lastReason?.note?.trim() ? ` (${_lastReason?.note?.trim()})` : ''}` : null;
    return response;
    /*
    const refunds = payment?.refunds || [];
    const reasonsForChange = payment?.reasonsForChange || [];
    const reasonsForCancellation = payment?.reasonsForCancellation || [];
    let reasons = [];
    if (refunds?.length) {
        for (let i = 0; i < refunds.length; i++) {
            const refund = refunds[i];
            let reason = `${'Refund'.translate(lang)}:`;
            let _reason = refund?.reason?.en !== 'Other' ? refund?.reason?.[lang] : refund.note;
            _reason = _reason?.trim();
            const ts = refund?.time?.ts;
            if (_reason) {
                reason += ` ${_reason}`;
                reasons.push({ reason, ts });
            }
        }
    }
    if (reasonsForChange?.length) {
        for (let i = 0; i < reasonsForChange.length; i++) {
            const item = reasonsForChange[i];
            let reason = `${'Change'.translate(lang)}:`;
            let _reason = item?.reason?.en !== 'Other' ? item?.reason?.[lang] : item?.note;
            _reason = _reason?.trim();
            const ts = item?.time?.ts;
            if (_reason) {
                reason += ` ${_reason}`;
                reasons.push({ reason, ts });
            }


            // let reason = `${'Change'.translate(lang)}:`;
            // let _reason = item?.value !== 'other' ? getHumanReadableReasonForChange(item?.value, lang) : item?.changes?.notes?.new;
            // _reason = _reason?.trim();
            // const ts = item?.time?.ts;
            // if (_reason) {
            //     reason += ` ${_reason}`;
            //     reasons.push({ reason, ts });
            // }
        }
    }
    if (reasonsForCancellation?.length) {
        for (let i = 0; i < reasonsForCancellation.length; i++) {
            const item = reasonsForCancellation[i];
            let reason = `${'Cancellation'.translate(lang)}:`;
            let _reason = item?.reason?.en?.toLowerCase() !== 'other' ? item?.reason?.[lang] : item?.note;
            _reason = _reason?.trim();
            const ts = item?.time?.ts;
            if (_reason) {
                reason += ` ${_reason}`;
                reasons.push({ reason, ts });
            }
        }
    }
    reasons?.sort((a, b) => a.ts - b.ts);
    if (reasons?.length) return reasons;

    return null;

    */
}
